import { Engine } from '@babylonjs/core/Engines/engine';

/** WebGL2 engine (WebGPU is not available for WebXR on the Quest browser yet). */
export function createEngine(canvas: HTMLCanvasElement): Engine {
  return new Engine(
    canvas,
    true,
    {
      xrCompatible: true,
      powerPreference: 'high-performance',
      stencil: false,
      preserveDrawingBuffer: false,
    },
    true,
  );
}
